import React from 'react'

const InputImageContext = React.createContext()

export const InputImageProvider = InputImageContext.Provider
export const InputImageConsumer = InputImageContext.Consumer

export default InputImageContext